import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfUse = () => {
  // Check for utm=mobile query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const isMobile = urlParams.get('utm') === 'mobile';
  const termsContent = `
**Effective Date:** 05/Oct/2025  
**Last Updated:** 05/Oct/2025  

## 1. Acceptance  
By using [https://metrorahi.resiara.com](https://metrorahi.resiara.com), you agree to these Terms. If not, please do not use the Website.

---

## 2. Website Purpose  
This Website provides **informational content** about the MetroRahi mobile app.  
It does not provide login/account features unless specified.  

You agree to use the Website lawfully and not misuse or disrupt it.

---

## 3. Accuracy of Information  
We try to provide accurate details, but we do **not guarantee** all info is error-free, complete, or current.  
We are not responsible for damages due to reliance on Website information.

---

## 4. Intellectual Property  
All Website content (logos, text, graphics, images) belongs to **Resiara Software Pvt. Ltd.**.  
You may not reproduce or commercialize content without permission.

---

## 5. External Links  
Our Website may link to third-party sites (social media, resources).  
We do not control or endorse third-party content and are not liable for their policies.

---

## 6. Limitation of Liability  
To the fullest extent permitted by law:  
- We are **not liable** for any damages (direct, indirect, incidental, or consequential) from use of the Website.  
- Our total liability is limited to the extent permitted under Indian law.  

---

## 7. Indemnification  
You agree to indemnify us against claims/damages from:  
- Your misuse of the Website  
- Your violation of these Terms  
- Your violation of applicable laws  

---

## 8. Termination  
We may suspend or terminate Website access anytime without notice.

---

## 9. Changes to Terms  
We may update Terms periodically. Continued use of the Website means acceptance of updates.

---

## 10. Governing Law  
These Terms are governed by the laws of **India**, under jurisdiction of **Jaipur, Rajasthan** courts.

---

## 11. Severability  
If any provision is invalid, remaining terms remain enforceable.

---

## 12. Entire Agreement  
These Terms + Privacy Policy = the entire agreement between you and Resiara Software Pvt. Ltd.

---

**By using MetroRahi, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.**

**Last Updated:** 05/Oct/2025

**Version:** 1.0`;

  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-document">
          {/* Header */}
          <motion.div
            className="policy-header"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {!isMobile && (
              <Link to="/" className="back-button">
                <ArrowLeft className="back-icon" />
                <span>Back</span>
              </Link>
            )}
            
            <div className="policy-title-section">
              <h1>Terms of Use</h1>
              <p>Website Terms of Use</p>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            className="policy-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <div className="policy-text">
              {termsContent.split('\n').map((line, index) => {
                if (line.startsWith('# ')) {
                  return <h1 key={index}>{line.substring(2)}</h1>;
                } else if (line.startsWith('## ')) {
                  return <h2 key={index}>{line.substring(3)}</h2>;
                } else if (line.startsWith('### ')) {
                  return <h3 key={index}>{line.substring(4)}</h3>;
                } else if (line.startsWith('**') && line.endsWith('**')) {
                  return <p key={index} className="bold-text">{line.substring(2, line.length - 2)}</p>;
                } else if (line.startsWith('- ')) {
                  return <li key={index}>{line.substring(2)}</li>;
                } else if (line.trim() === '---') {
                  return <hr key={index} className="section-divider" />;
                } else if (line.trim() === '') {
                  return <br key={index} />;
                } else {
                  return <p key={index}>{line}</p>;
                }
              })}
            </div>
          </motion.div>

          {/* Footer */}
          <motion.div
            className="policy-footer"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="company-info">
              <p>Brought to you by <a href="https://resiara.com" target="_blank" rel="noopener noreferrer" className="company-link">Resiara Software Pvt. Ltd.</a></p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
